export const kioskMessages = {
  en: {
    kiosk: {
      appTitle: 'Worker Kiosk',
      appDescription: 'Touch-first production session, batch scanning, output, rejects, downtime, and earnings.',
      nav: {
        workSession: 'Work session',
        personalKpi: 'Personal KPI',
        earnings: 'Earnings',
      },
      session: {
        eyebrow: 'Production session',
        title: 'Work session',
        description: 'Select a lot, record output, and report downtime.',
        worker: 'Worker',
        changeWorker: 'Change',
        selectWorker: 'Select your name',
        order: 'Order',
        selectOrder: 'Select order',
        lot: 'Lot',
        scanLot: 'Scan or enter lot number',
        lotPlaceholder: 'L-2026-014-03',
        scan: 'Open lot',
        notFound: 'Lot not found in the selected order.',
        selectedLot: 'Selected lot',
        currentStage: 'Stage',
        recordOutput: 'Record output',
        completed: 'Good',
        rejected: 'Reject',
        rework: 'Rework',
        record: 'Record',
        recording: 'Recording…',
        closeStage: 'Close stage',
        closeConfirm: 'Close the current stage for this lot?',
        progressRecorded: 'Output recorded for {lot}.',
        stageClosed: 'Stage closed for {lot}.',
        downtime: 'Downtime',
        reportDowntime: 'Report downtime',
        selectReason: 'Select reason',
        report: 'Report',
        reporting: 'Reporting…',
        notes: 'Notes',
        clear: 'Clear',
        backToWork: 'Back to work session',
        activeLots: 'Active lots',
        noLots: 'No active lots for this order.',
        noOrders: 'No active production orders.',
        loading: 'Loading session data…',
        error: 'Failed to load session data.',
        retry: 'Retry',
        selectEmployee: 'Select a worker to continue.',
        ready: 'Ready',
        inProgress: 'In progress',
        startSession: 'Start session',
        starting: 'Starting…',
        pause: 'Pause',
        resume: 'Resume',
        finish: 'Finish',
        finishing: 'Finishing…',
        sessionStatus: 'Session',
        sessionActive: 'Active',
        sessionPaused: 'Paused',
        sessionFinished: 'Finished',
        started: 'Session started.',
        pausedMsg: 'Session paused.',
        resumedMsg: 'Session resumed.',
        finishedMsg: 'Session finished.',
        sessionActiveNotice: 'Active session in progress.',
        selectLotFirst: 'Select a lot to start a session.',
        elapsed: 'Elapsed {minutes} min',
        offline: 'You are offline',
        pending: 'Pending actions',
        pendingCount: '{count} pending',
        syncNow: 'Sync now',
        syncing: 'Syncing…',
        queued: 'Queued — will sync when back online.',
        queuedMessage: 'Actions will be sent automatically when back online.',
        liveEstimate: 'Est. this session',
        ratePerPair: 'Rate / pair',
        noRate: 'No piece rate set for this stage.',
        shift: 'Shift',
        shiftDay: 'Day',
        shiftNight: 'Night',
        cardLogin: 'Card / PIN',
        cardUid: 'Card UID',
        cardPlaceholder: 'Swipe card or enter UID',
        pin: 'PIN',
        login: 'Log in',
        machine: 'Machine',
        noMachines: 'No machines available',
        selectMachine: 'Select machine…',
        noMachine: 'No machine',
        reasons: {
          machine_breakdown: 'Machine breakdown',
          setup_change: 'Setup / size change',
          yarn_shortage: 'Yarn shortage',
          power_outage: 'Power outage',
          no_assignment: 'No operator assigned',
          qc_wait: 'Waiting for QC',
        },
        scanOrderOrLot: 'Scan order or lot barcode',
        swipeHint: 'Swipe your card or select your name to start on this lot.',
        activeOnLot: 'Already active on lot {lot}.',
        switchToActiveLot: 'This worker has an active session on {lot}. Switch to it?',
        stageComplete: 'Stage complete. Tap Close stage when ready.',
      },
      kpi: {
        eyebrow: 'Personal performance',
        title: 'Personal KPI',
        description: 'Your daily output by stage.',
        date: 'Date',
        completed: 'Good',
        rejected: 'Reject',
        rework: 'Rework',
        total: 'Total completed',
        noData: 'No output recorded for this date.',
        loading: 'Loading your output…',
        error: 'Failed to load output.',
        retry: 'Retry',
        stage: 'Stage',
      },
      earnings: {
        eyebrow: 'Piecework estimate',
        title: 'Earnings',
        description: 'Estimated piecework earnings from your recorded output.',
        date: 'Date',
        pieceRate: 'Rate / pair',
        completedPairs: 'Good pairs',
        estimatedEarnings: 'Estimated earnings',
        estimatedNote: 'Estimate based on completed pairs and the entered rate. Final payroll is calculated by the HR module.',
        noData: 'No output recorded for this date.',
        loading: 'Loading earnings…',
        error: 'Failed to load earnings.',
        retry: 'Retry',
      },
      state: {
        loading: 'Loading…',
        error: 'Something went wrong.',
        retry: 'Retry',
        noData: 'No data available.',
      },
    },
  },
  uz: {
    kiosk: {
      appTitle: 'Ishchi kioski',
      appDescription: 'Sensorli ishlab chiqarish seansi, partiyani skanerlash, ishlab chiqarish, radlar, to‘xtalishlar va daromad.',
      nav: {
        workSession: 'Ish seansi',
        personalKpi: 'Shaxsiy KPI',
        earnings: 'Daromad',
      },
      session: {
        eyebrow: 'Ishlab chiqarish seansi',
        title: 'Ish seansi',
        description: 'Partiyani tanlang, ishlab chiqarishni qayd eting va to‘xtalishlar haqida xabar bering.',
        worker: 'Ishchi',
        changeWorker: 'O‘zgartirish',
        selectWorker: 'Ismingizni tanlang',
        order: 'Buyurtma',
        selectOrder: 'Buyurtmani tanlang',
        lot: 'Partiya',
        scanLot: 'Partiya raqamini skanerlang yoki kiriting',
        lotPlaceholder: 'L-2026-014-03',
        scan: 'Partiyani ochish',
        notFound: 'Tanlangan buyurtmada partiya topilmadi.',
        selectedLot: 'Tanlangan partiya',
        currentStage: 'Bosqich',
        recordOutput: 'Ishlab chiqarishni qayd etish',
        completed: 'Yaroqli',
        rejected: 'Rad',
        rework: 'Qayta ishlash',
        record: 'Qayd etish',
        recording: 'Qayd etilmoqda…',
        closeStage: 'Bosqichni yopish',
        closeConfirm: 'Ushbu partiya uchun joriy bosqichni yopish kerakmi?',
        progressRecorded: '{lot} uchun ishlab chiqarish qayd etildi.',
        stageClosed: '{lot} uchun bosqich yopildi.',
        downtime: 'To‘xtalish',
        reportDowntime: 'To‘xtalish haqida xabar berish',
        selectReason: 'Sababni tanlang',
        report: 'Xabar berish',
        reporting: 'Yuborilmoqda…',
        notes: 'Izohlar',
        clear: 'Tozalash',
        backToWork: 'Ish seansiga qaytish',
        activeLots: 'Faol partiyalar',
        noLots: 'Ushbu buyurtma uchun faol partiyalar mavjud emas.',
        noOrders: 'Faol ishlab chiqarish buyurtmalari mavjud emas.',
        loading: 'Seans ma’lumotlari yuklanmoqda…',
        error: 'Seans ma’lumotlarini yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        selectEmployee: 'Davom etish uchun ishchini tanlang.',
        ready: 'Tayyor',
        inProgress: 'Jarayonda',
        startSession: 'Seansni boshlash',
        starting: 'Boshlanmoqda…',
        pause: 'Pauza',
        resume: 'Davom ettirish',
        finish: 'Yakunlash',
        finishing: 'Yakunlanmoqda…',
        sessionStatus: 'Seans',
        sessionActive: 'Faol',
        sessionPaused: 'Pauzada',
        sessionFinished: 'Yakunlangan',
        started: 'Seans boshlandi.',
        pausedMsg: 'Seans pauzaga qo‘yildi.',
        resumedMsg: 'Seans davom ettirildi.',
        finishedMsg: 'Seans yakunlandi.',
        sessionActiveNotice: 'Faol seans davom etmoqda.',
        selectLotFirst: 'Seansni boshlash uchun partiyani tanlang.',
        elapsed: '{minutes} daq o‘tdi',
        offline: 'Siz oflaynsiz',
        pending: 'Kutilayotgan amallar',
        pendingCount: '{count} ta kutilmoqda',
        syncNow: 'Hoziroq sinxronlash',
        syncing: 'Sinxronlanmoqda…',
        queued: 'Navbatga qo‘yildi — tarmoq tiklangach yuboriladi.',
        queuedMessage: 'Amallar tarmoq tiklangach avtomatik yuboriladi.',
        liveEstimate: 'Ushbu seans uchun taxmin',
        ratePerPair: 'Jufti uchun tarif',
        noRate: 'Ushbu bosqich uchun ishbay tarif o‘rnatilmagan.',
        shift: 'Smena',
        shiftDay: 'Kunduzgi',
        shiftNight: 'Tungi',
        cardLogin: 'Karta / PIN',
        cardUid: 'Karta UID',
        cardPlaceholder: 'Kartani suring yoki UID kiriting',
        pin: 'PIN',
        login: 'Kirish',
        machine: 'Mashina',
        noMachines: 'Mashinalar mavjud emas',
        selectMachine: 'Mashinani tanlang…',
        noMachine: 'Mashina yo‘q',
        reasons: {
          machine_breakdown: 'Mashina buzilishi',
          setup_change: 'Sozlash / o‘lcham almashtirish',
          yarn_shortage: 'Ip yetishmasligi',
          power_outage: 'Elektr uzilishi',
          no_assignment: 'Operator tayinlanmagan',
          qc_wait: 'Sifat nazoratini kutish',
        },
        scanOrderOrLot: 'Buyurtma yoki partiya shtrix-kodini skanerlang',
        swipeHint: 'Ushbu partiyada ishlashni boshlash uchun kartani suring yoki ismingizni tanlang.',
        activeOnLot: '{lot} partiyasida faol seans mavjud.',
        switchToActiveLot: 'Bu ishchining {lot} partiyasida faol seansi bor. Unga o‘tish kerakmi?',
        stageComplete: 'Bosqich yakunlandi. Tayyor bo‘lgach “Bosqichni yopish” tugmasini bosing.',
      },
      kpi: {
        eyebrow: 'Shaxsiy ko‘rsatkichlar',
        title: 'Shaxsiy KPI',
        description: 'Bosqichlar kesimida kunlik ishlab chiqarishingiz.',
        date: 'Sana',
        completed: 'Yaroqli',
        rejected: 'Rad',
        rework: 'Qayta ishlash',
        total: 'Jami bajarilgan',
        noData: 'Ushbu sana uchun ishlab chiqarish qayd etilmagan.',
        loading: 'Ishlab chiqarishingiz yuklanmoqda…',
        error: 'Ishlab chiqarishni yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        stage: 'Bosqich',
      },
      earnings: {
        eyebrow: 'Ishbay baho',
        title: 'Daromad',
        description: 'Qayd etilgan ishlab chiqarish asosida taxminiy ishbay daromad.',
        date: 'Sana',
        pieceRate: 'Jufti uchun tarif',
        completedPairs: 'Yaroqli juftlar',
        estimatedEarnings: 'Taxminiy daromad',
        estimatedNote: 'Hisob yaroqli juftlar va kiritilgan tarif asosida. Yakuniy ish haqi HR moduli tomonidan hisoblanadi.',
        noData: 'Ushbu sana uchun ishlab chiqarish qayd etilmagan.',
        loading: 'Daromad yuklanmoqda…',
        error: 'Daromadni yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
      },
      state: {
        loading: 'Yuklanmoqda…',
        error: 'Xatolik yuz berdi.',
        retry: 'Qayta urinish',
        noData: 'Ma’lumot mavjud emas.',
      },
    },
  },
  ru: {
    kiosk: {
      appTitle: 'Киоск рабочего',
      appDescription: 'Сенсорная производственная сессия, сканирование партий, выработка, брак, простои и заработок.',
      nav: {
        workSession: 'Рабочая сессия',
        personalKpi: 'Личный KPI',
        earnings: 'Заработок',
      },
      session: {
        eyebrow: 'Производственная сессия',
        title: 'Рабочая сессия',
        description: 'Выберите партию, запишите выработку и сообщите о простое.',
        worker: 'Рабочий',
        changeWorker: 'Изменить',
        selectWorker: 'Выберите своё имя',
        order: 'Заказ',
        selectOrder: 'Выберите заказ',
        lot: 'Партия',
        scanLot: 'Сканируйте или введите номер партии',
        lotPlaceholder: 'L-2026-014-03',
        scan: 'Открыть партию',
        notFound: 'Партия не найдена в выбранном заказе.',
        selectedLot: 'Выбранная партия',
        currentStage: 'Этап',
        recordOutput: 'Записать выработку',
        completed: 'Годные',
        rejected: 'Брак',
        rework: 'Переработка',
        record: 'Записать',
        recording: 'Запись…',
        closeStage: 'Закрыть этап',
        closeConfirm: 'Закрыть текущий этап для этой партии?',
        progressRecorded: 'Выработка записана для {lot}.',
        stageClosed: 'Этап закрыт для {lot}.',
        downtime: 'Простой',
        reportDowntime: 'Сообщить о простое',
        selectReason: 'Выберите причину',
        report: 'Сообщить',
        reporting: 'Отправка…',
        notes: 'Примечания',
        clear: 'Очистить',
        backToWork: 'Назад к рабочей сессии',
        activeLots: 'Активные партии',
        noLots: 'Нет активных партий для этого заказа.',
        noOrders: 'Нет активных производственных заказов.',
        loading: 'Загрузка данных сессии…',
        error: 'Не удалось загрузить данные сессии.',
        retry: 'Повторить',
        selectEmployee: 'Выберите рабочего, чтобы продолжить.',
        ready: 'Готов',
        inProgress: 'В работе',
        startSession: 'Начать сессию',
        starting: 'Запуск…',
        pause: 'Пауза',
        resume: 'Продолжить',
        finish: 'Завершить',
        finishing: 'Завершение…',
        sessionStatus: 'Сессия',
        sessionActive: 'Активна',
        sessionPaused: 'Пауза',
        sessionFinished: 'Завершена',
        started: 'Сессия начата.',
        pausedMsg: 'Сессия на паузе.',
        resumedMsg: 'Сессия продолжена.',
        finishedMsg: 'Сессия завершена.',
        sessionActiveNotice: 'Активная сессия в процессе.',
        selectLotFirst: 'Выберите партию, чтобы начать сессию.',
        elapsed: 'Прошло {minutes} мин',
        offline: 'Вы офлайн',
        pending: 'Ожидающие действия',
        pendingCount: 'Ожидает: {count}',
        syncNow: 'Синхронизировать',
        syncing: 'Синхронизация…',
        queued: 'В очереди — отправится при восстановлении связи.',
        queuedMessage: 'Действия отправятся автоматически при восстановлении связи.',
        liveEstimate: 'Оценка за сессию',
        ratePerPair: 'Ставка / пара',
        noRate: 'Сдельная ставка для этого этапа не задана.',
        shift: 'Смена',
        shiftDay: 'День',
        shiftNight: 'Ночь',
        cardLogin: 'Карта / PIN',
        cardUid: 'UID карты',
        cardPlaceholder: 'Проведите картой или введите UID',
        pin: 'ПИН',
        login: 'Войти',
        machine: 'Станок',
        noMachines: 'Нет доступных станков',
        selectMachine: 'Выберите оборудование…',
        noMachine: 'Без оборудования',
        reasons: {
          machine_breakdown: 'Поломка оборудования',
          setup_change: 'Переналадка / смена размера',
          yarn_shortage: 'Нехватка пряжи',
          power_outage: 'Отключение электроэнергии',
          no_assignment: 'Не назначен оператор',
          qc_wait: 'Ожидание ОТК',
        },
        scanOrderOrLot: 'Сканируйте штрих-код заказа или партии',
        swipeHint: 'Проведите картой или выберите имя, чтобы начать работу над партией.',
        activeOnLot: 'Уже есть активная сессия на партии {lot}.',
        switchToActiveLot: 'У этого рабочего есть активная сессия на партии {lot}. Переключиться на неё?',
        stageComplete: 'Этап завершён. Нажмите «Закрыть этап», когда будете готовы.',
      },
      kpi: {
        eyebrow: 'Личные показатели',
        title: 'Личный KPI',
        description: 'Ваша дневная выработка по этапам.',
        date: 'Дата',
        completed: 'Годные',
        rejected: 'Брак',
        rework: 'Переработка',
        total: 'Всего выполнено',
        noData: 'Нет выработки за эту дату.',
        loading: 'Загрузка выработки…',
        error: 'Не удалось загрузить выработку.',
        retry: 'Повторить',
        stage: 'Этап',
      },
      earnings: {
        eyebrow: 'Сдельная оценка',
        title: 'Заработок',
        description: 'Оценочный сдельный заработок по записанной выработке.',
        date: 'Дата',
        pieceRate: 'Ставка / пара',
        completedPairs: 'Годных пар',
        estimatedEarnings: 'Оценочный заработок',
        estimatedNote: 'Расчёт на основе годных пар и введённой ставки. Итоговая зарплата рассчитывается модулем HR.',
        noData: 'Нет выработки за эту дату.',
        loading: 'Загрузка заработка…',
        error: 'Не удалось загрузить заработок.',
        retry: 'Повторить',
      },
      state: {
        loading: 'Загрузка…',
        error: 'Что-то пошло не так.',
        retry: 'Повторить',
        noData: 'Нет данных.',
      },
    },
  },
}
